'use client';

import { useNavigationState } from '@wwe-portal/web/hooks/offer/category-navigation-state';
import { clearSearchParams } from '@wwe-portal/web/utils/location';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const CategoryNavigationListener = ({
  availableItems,
  enabled,
}: {
  availableItems: string[];
  enabled: boolean;
}) => {
  const searchParams = useSearchParams();

  const category = searchParams.get('category');

  useEffect(() => {
    if (!enabled) return;
    if (category && availableItems.includes(category)) {
      useNavigationState.getState().setForceActiveId(category);
      clearSearchParams('category');
    }
  }, [category, enabled]);
  return null;
};
